import { action, computed, observable } from 'mobx';
import Abstract from './abstract';

export class TipsCart extends Abstract {
  @observable selected = [];
  @observable checkedKey: string | null = null;

  @computed get templates() {
    const res = this.selected.map(item => item.content.template);
    return nx.unique(nx.flatten(res), 'templateUuid');
  }

  @computed get templatesIds() {
    return this.templates.map(item => item.templateUuid);
  }

  @computed get businesses() {
    const res = this.selected.map(item => item.current);
    return nx.unique(res, 'uuid');
  }

  @computed get count() {
    return this.selected.length;
  }

  @computed get checkedTemplateIds() {
    if (!this.checkedKey) return [];
    const item = this.selected.find(s => s.content.businessContentId === this.checkedKey);
    return item ? [item.content.template.templateUuid] : [];
  }

  @computed get cartList() {
    const items = this.selected;
    if (items.length === 0) return [];
    const res = nx.groupBy(items, 'current.uuid');
    const tree = [];

    nx.forIn(res, (key, value) => {
      const business = this.businesses.find(item => item.uuid === key);
      const children = value.map(item => ({
        value: item.content.businessContentId,
        label: item.content.template.templateName,
      }));
      tree.push({ value: key, label: business.cnName, children });
    });
    return tree;
  }

  @computed get checkedContentUuids() {
    if (!this.checkedKey) return [];
    return [this.checkedKey];
  }

  @action
  setChecked(key: string | null) {
    this.checkedKey = key;
  }

  @action
  empty() {
    this.checkedKey = null;
    this.selected.length = 0;
  }

  @action
  remove(inValue) {
    const value = Array.isArray(inValue) ? inValue : [inValue];
    if (this.checkedKey && value.includes(this.checkedKey)) {
      this.checkedKey = null;
    }
    nx.remove(this.selected, (_, item) => {
      return value.includes(item.content.businessContentId);
    });
  }

  @action
  removeChecked() {
    if (this.checkedKey) {
      this.remove(this.checkedKey);
    }
  }

  @action
  removeBusiness(businessUuid: string) {
    const contentIds = this.selected
      .filter(item => item.current.uuid === businessUuid)
      .map(item => item.content.businessContentId);
    if (this.checkedKey && contentIds.includes(this.checkedKey)) {
      this.checkedKey = null;
    }
    nx.remove(this.selected, (_, item) => item.current.uuid === businessUuid);
  }

  includes(inBusinessContentId) {
    const ids = this.selected.map(item => item.content.businessContentId);
    return ids.includes(inBusinessContentId);
  }
}
